import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContent, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

import List from "@mui/material/List";
import PropTypes from "prop-types";
import * as React from "react";
import CartItem from "../cart-item";
import { Link } from 'react-router-dom';
import IProduct from '../../interfaces/IProduct';
import IDelivery from '../../interfaces/IDelivery';
import { ActionButton, ActionButtonSmall } from '../../utils/action-button';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Add, ChevronLeft } from '@mui/icons-material';

export default function OrderMenuModalMobile(props: { onClose: any; open: any; cartItems: IProduct[]; totalPrice: any; deliveryOptions?: IDelivery; setCartState: any; drinks?: IProduct[]; addItem?: any }) {
    const { onClose, open, cartItems, totalPrice, deliveryOptions, setCartState, drinks } = props;
    const minAmountExceeded = totalPrice - deliveryOptions?.price! < deliveryOptions?.amountMin!;

    const handleAdd = (prod: IProduct) => {
        let newProd = {...prod, quantity: 1}
        props.addItem(newProd);
    }

    const cartHasDrinks = (): boolean => {
        let drinksInCart: IProduct[] = [];
        cartItems.map(
            item => {
                drinks?.map(drink => {
                    if (item.id === drink.id) {
                        drinksInCart.push(drink);
                    }
                })
            }
        )

        return drinksInCart.length > 0;
    }

    return (
        <Dialog fullScreen open={open}>
            <DialogTitle color="primary">🛒 Winkelmandje
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <div className="flex flex-col h-full">
                    <div className="h-full overflow-auto">

                        {cartItems.length === 0 && <div className="empty-cart">Vul het mandje om verder te gaan</div>}
                        {cartItems.length > 0 && cartItems.map((product: IProduct, index: number) => <CartItem cart={cartItems} setCartState={setCartState} product={product} key={index} isOrderPage={true} />)}
                    </div>

                    {cartItems.length > 0 &&
                        <div className="order-payment-details">
                            <div className="flex flex-col pb-2">
                                {minAmountExceeded &&
                                    <>
                                        <div className="amount-remaining">
                                            <div>Benodigd bedrag om het bestelbedrag te bereiken&nbsp;</div>
                                            <div className="font-semibold">€{(deliveryOptions?.amountMin! - (totalPrice - deliveryOptions?.price!)).toFixed(2).replace('.', ',')}</div>
                                        </div>
                                        <p className="min-amount-warning">Ons minimum bestelbedrag bedraagt
                                            €{deliveryOptions?.amountMin.toFixed(2).replace('.', ',')} (excl.
                                            bezorgkosten) voordat u kunt bestellen</p>
                                    </>
                                }

                                {!cartHasDrinks() &&
                                    <div className="extra-item-section">
                                        <p className="text-xs text-gray-500">Geniet van een koel drankje voor bij de maaltijd 🥤</p>

                                        <ScrollContainer className="extra-item-selector" horizontal={true}>
                                            {drinks?.map(drink =>
                                                <div key={drink.id} className="grow px-1">
                                                    <ActionButtonSmall
                                                        onClick={() => handleAdd(drink)}
                                                        variant="contained"
                                                        color="secondary">
                                                        <Add fontSize="small"/> {drink.name}
                                                    </ActionButtonSmall>
                                                </div>
                                            )
                                            }
                                        </ScrollContainer>
                                    </div>
                                }
                                <div className="flex">
                                    <div className="flex-1">
                                        Bezorgkosten:
                                    </div>
                                    <div className="euro-amount">
                                        €{deliveryOptions?.price.toFixed(2).replace(".", ",")}
                                    </div>
                                </div>
                                <div className="flex font-bold pt-1">
                                    <div className="flex-1">
                                        Totaal:
                                    </div>
                                    <div className="euro-amount">
                                        €{totalPrice.toFixed(2).replace(".", ",")}
                                    </div>
                                </div>
                            </div>
                            {minAmountExceeded ?
                                <ActionButton
                                    onClick={onClose}
                                    variant="contained"
                                    color="secondary">
                                    <ChevronLeft />
                                    Terug naar producten
                                </ActionButton>
                                :
                                <ActionButton
                                    component={Link}
                                    to={`payment`}
                                    state={{cartItems}}
                                    variant="contained"
                                    color="secondary">
                                    💸 Afrekenen (€{totalPrice.toFixed(2).replace(".", ",")})
                                </ActionButton>
                            }
                        </div>
                    }


                </div>
            </DialogContent>

            <List sx={{ pt: 0 }}>
            </List>
        </Dialog>
    );
}
OrderMenuModalMobile.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    cartItems: PropTypes.array
};